import {
  SelectDropDown,
  SelectItemDropDown,
  type SelectItemProps,
  type SelectProps,
} from '@pixel-party/SelectDropdown/v2';
import {forwardRef} from 'react';

export const SelectField = forwardRef<HTMLButtonElement, SelectProps>(
  ({label, required, ...props}, ref) => (
    <SelectDropDown
      {...props}
      ref={ref}
      required={required}
      label={label ? `${label}${required ? ' *' : ''}` : undefined}
    />
  ),
);

SelectField.displayName = 'SelectField';

export const SelectItem = forwardRef<HTMLDivElement, SelectItemProps>(
  (props, ref) => (
    <SelectItemDropDown
      {...props}
      ref={ref}
    />
  ),
);

SelectItem.displayName = 'SelectItem';
